module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Metrics","intro":"This is an overview of all supported metrics and values. It is used to translate this software."},"nl":{"title":"Metingen","intro":"Deze pagina geeft een overzicht van alle verschillende meetwaarden. Deze pagina wordt gebruikt voor het controleren van vertalingen."}}')
  delete Component.options._Ctor
}
